var map = {
	"./arrow-left.svg": 5085,
	"./arrow-right.svg": 2074,
	"./chevron-left.svg": 7319,
	"./chevron-right.svg": 1916,
	"./cross.svg": 2448,
	"./decoration-angle-left-bottom.svg": 3077,
	"./decoration-angle-left-top.svg": 5199,
	"./decoration-angle-right-bottom.svg": 4368,
	"./decoration-angle-right-top.svg": 509,
	"./decoration-gray-points.svg": 6312,
	"./decoration-white-points.svg": 5170,
	"./hamburger.svg": 1676,
	"./logo.svg": 1972,
	"./mail.svg": 7896,
	"./message-mark.svg": 1727,
	"./minus.svg": 6332,
	"./next.svg": 3847,
	"./phone-ring.svg": 231,
	"./phone.svg": 7802,
	"./plus.svg": 1881,
	"./prev.svg": 3183,
	"./search.svg": 2938,
	"./service-icon1.svg": 5105,
	"./service-icon2.svg": 4509,
	"./service-icon3.svg": 8182,
	"./service-icon4.svg": 5145,
	"./social-facebook.svg": 8455,
	"./social-instagram.svg": 5750,
	"./social-line.svg": 8229,
	"./social-linkedin.svg": 3842,
	"./social-pinterest.svg": 5805,
	"./social-twitter.svg": 6379,
	"./social-youtube.svg": 1966,
	"./title-news.svg": 2219,
	"./title-partner.svg": 1085,
	"./title-products.svg": 564,
	"./title-service.svg": 2091
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8091;